export const ROOM_OPTIONS = (t: any) => [
    {
        value: 'small_meeting_room',
        label: t('events.rooms.small_meeting_room'),
    },
    { value: 'main_meeting_room', label: t('events.rooms.main_meeting_room') },
    { value: 'all', label: t('events.rooms.all') },
]

export const PARTICIPANTS_OPTIONS = (t: any) => [
    { value: 'all', label: t('events.participants.all') },
    { value: 'department', label: t('events.participants.department') },
    { value: 'team', label: t('events.participants.team') },
]

export const EVENT_TYPE_OPTIONS = (t: any) => [
    { value: 'birthday', label: t('events.type.birthday') },
    { value: 'meeting', label: t('events.type.meeting') },
    { value: 'training', label: t('events.type.training') },
    { value: 'award', label: t('events.type.award') },
    { value: 'team_building', label: t('events.type.team_building') },
    { value: 'interview', label: t('events.type.interview') },
    { value: 'conference', label: t('events.type.conference') },
    { value: 'workshop', label: t('events.type.workshop') },
    { value: 'other', label: t('events.type.other') },
]
